import { render } from "./MenuOption.vue?vue&type=template&id=bb682d56&scoped=true"
import script from "./MenuOption.vue?vue&type=script&lang=js"
export * from "./MenuOption.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=bb682d56&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb682d56"]])

export default __exports__